import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { RequestStatus } from '../configs/service'
import {
  selectCommitmentItemsByProgramType,
  selectCommitmentItemsLoadingStatus,
} from '../features/partner360/commitment'

export function useJBPCommitmentData() {
  const data = useSelector(selectCommitmentItemsByProgramType)
  const loadingStatus = useSelector(selectCommitmentItemsLoadingStatus)

  const isLoading = useMemo(() => {
    return loadingStatus === RequestStatus.PENDING
  }, [loadingStatus])

  return {
    data,
    isLoading,
  }
}
